var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoData(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 35,
    fill: "#CCCDD3",
    fillOpacity: 0.62
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1234_1198)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.6655 32.0259C26.0415 32.0259 27.161 30.9064 27.161 29.5304C27.161 29.1437 27.0726 28.7773 26.9149 28.4502L29.711 25.6127C30.1458 25.9806 30.7075 26.203 31.3202 26.203C31.9894 26.203 32.5975 25.9378 33.0461 25.5074L35.5894 27.9658C35.5181 28.1976 35.4795 28.4437 35.4795 28.6985C35.4795 30.0746 36.5989 31.1941 37.975 31.1941C39.3314 31.1941 40.4377 30.1061 40.4691 28.7572L42.8732 27.1418C43.3245 27.5895 43.9453 27.8667 44.6298 27.8667C46.0059 27.8667 47.1254 26.7471 47.1254 25.3712C47.1254 23.9952 46.0059 22.8756 44.6298 22.8756C43.2537 22.8756 42.1343 23.9952 42.1343 25.3712C42.1343 25.4569 42.1386 25.5416 42.1471 25.6251L39.9118 27.1271C39.4539 26.5638 38.756 26.203 37.975 26.203C37.4642 26.203 36.9889 26.3576 36.5929 26.622L33.8055 23.9277C33.8119 23.855 33.8158 23.7817 33.8158 23.7075C33.8158 22.3314 32.6963 21.2119 31.3202 21.2119C29.9442 21.2119 28.8247 22.3315 28.8247 23.7075C28.8247 23.844 28.8362 23.978 28.8574 24.1087L25.7358 27.2765C25.4112 27.1217 25.0483 27.0348 24.6655 27.0348C23.2894 27.0348 22.1699 28.1544 22.1699 29.5304C22.1699 30.9064 23.2895 32.0259 24.6655 32.0259Z",
    fill: "#8A939F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2931 47.8309V32.0258H42.9657V47.8309H39.6383V34.5214H36.311V47.8309H32.9836V29.5303H29.6562V47.8309H26.3288V36.1851H23.0014V47.8309H20.5059V49.4946H48.7887V47.8309H46.2931Z",
    fill: "#8A939F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1234_1198"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.2828,
    height: 28.2828,
    fill: "white",
    transform: "translate(20.5059 21.2119)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/no_data.13018a56c05136d7dd86aaa8ca7387b7.svg";
export { ForwardRef as ReactComponent };